import React, { useState } from "react";
import '../../../../App.css';
import { useTheme } from "@chakra-ui/react";
import { ChevronDownIcon, ChevronUpIcon } from "@chakra-ui/icons";
import { Link } from "react-router-dom";
import { resetStepOpen, useNavbarContext } from "../navbar/navbar";
import { styles } from "./styles";
import MenuCustom from "../../../menuCustom/menuCustom";
import { useAppContext } from "../../../../App";

export function DropdownCustom({
    items,
    route,
    dropName
}) {
  const {selectedCategory, setAppType} = useAppContext();
  const {stepOpen, setStepOpen, handleToggleMenu} = useNavbarContext();
  const theme = useTheme();
  const style = styles(theme);
  
  const submenuItems = selectedCategory?
   selectedCategory.cursos?.map(curso => ({
    ...curso,
    name: curso.NombreCurso,
    id: curso.IdCurso
  })) : [];

  return (
    <div>
      <label
        className="sansation-bold"
        onMouseOver={() =>{ handleToggleMenu(dropName); setAppType(route)}}
        onClick={() =>  null}
        style={{...style.tagMenu, color: theme.color.text.secondary}}
      >
        {dropName.toUpperCase()} {stepOpen[dropName] ? <ChevronDownIcon /> : <ChevronUpIcon />}
      </label>
      {stepOpen[dropName] &&
      <div 
        style={style.menuList}
        onMouseLeave={() => setStepOpen(resetStepOpen)}
      >
        <div style={style.mainManu}>
          <MenuCustom
            id={`navbar-drop`}
            title={'CATEGORIAS'}
            items={items}
            addItemToPath={true}
            itemRedirectTo={`/categorias-general/${route}`}
            titleRedirectTo={`/categorias-general/${route}`}
            customActionOnItemclick={() => setStepOpen(resetStepOpen)}
          />
        </div>
        {submenuItems && selectedCategory &&
        <div style={style.subMenu} className="sansation-bold">
          <MenuCustom
            title={'CURSOS'}
            titleRedirectTo={`/categorias-general/${route}`}
            itemRedirectTo={`/formulario-inscripcion/${route}/${selectedCategory.name}`}
            addItemToPath={true}
            items={submenuItems}
            itemToPathById={true}
            customActionOnItemclick={() => setStepOpen(resetStepOpen)}
          />
          <div style={style.professionalPath} onClick={() => setStepOpen(resetStepOpen)}>
            <Link  to={'/trayectoria'}>
              TRAYECTO PROFESIONAL
            </Link>
          </div>
        </div>}
      </div>}
    </div>
  );
}